import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { branch, renderNothing } from 'recompose'

const GpuSku = ({ gpuSku }) => {
  return (
    <span>{ gpuSku }</span>
  )
}

const NotebookGpuSku = branch(
  ({ segment }) => segment === 'Notebook',
  renderNothing
)(GpuSku)

export default NotebookGpuSku
